import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useDropScaleFile} from './useDropScaleFile.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';

const SIZES = [3,4,5,6,7,8,9,10,11,12];

const ScaleEffectComponent = ({effect}) => { 
    let ref = useRef(undefined);
    let [scale, setScale] = useState(effect.scale);
    let [annotation, setAnnotation] = useState(effect.annotation || "");

    const onChangeSize = useCallback(e => {
        let size = e.value;
        let _scale = scale;
        if (size < scale.length) {
            _scale = _scale.slice(0, size);
        } else if (size > scale.length) {
            for (let i=scale.length; i < size; i++) {
                _scale.push("2/1");
            }
        }
        setScale(_scale);
        effect.scale = _scale;
    }, [setScale, scale, effect]);

    const onChangeAnnotation = useCallback(e => {
        let _annotation = e.target.value;
        setAnnotation(_annotation);
        effect.annotation = _annotation;
    }, [setAnnotation, effect]);

    const onChange = useCallback((e, i) => {
        let _scale = [... scale];
        _scale[i] = e.target.value;
        setScale(_scale);
        effect.scale = _scale;
    }, [setScale, effect, scale]);

    const toggleNote = useCallback((i) => {
        let subset = [... effect.subset];
        if (!subset[i]) {
            subset[i] = true;
        } else {
            subset[i] = false;
        }
        effect.subset = subset;
        setScale([... scale]);
    }, [setScale, scale, effect]);

    useDropScaleFile({ref, effect, setScale, setAnnotation: (x) => onChangeAnnotation({target: {value: x}})});

    return (
        <div ref={ref} className="scale-component">
          <div className="scale-data">
          <Dropdown
            onChange={onChangeSize}
            value={{value: scale.length, label: scale.length}}
            options={SIZES.map(x => ({label: x, value: x}))}
          />
          <EffectParameterSlider
            parameter={effect.referencePitchParameter}
            isParameter={true}
            root={1}
            min={150}
            max={400}
            name="Reference Pitch"
            units="Hz"
          />
          <div className="scale-notes">
            {scale.map(
                (x, i) =>
                    <div className="note-row">
                      <div onClick={() => toggleNote(i)} className={effect.subset[i] ? "note on dot" : "note off dot"}></div>
                      <input className="scale-note" onChange={(e) => onChange(e, i)} value={x}/>
                    </div>) }
          </div>
          </div>
          <Input
            type="textarea"
            value={annotation}
            className="comment-text"
            placeholder="Write a comment here"
            onChange={onChangeAnnotation}/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScaleEffectComponent);
